module.exports = __webpack_public_path__ + "img/xrp.f9f070e1.png";